'use strict';

var _ = require('lodash');
var UserProfileController = function UserProfileController($scope, UserManagementConstants, FeatureToggleService) {
  $scope.roles = _.map($scope.user.roles, _.toUpperCase);
  $scope.location = $scope.user.cityCode;
  $scope.email = $scope.user.email;
  $scope.userName = $scope.user.firstName + ' ' + $scope.user.lastName;
  $scope.showMarketLegResponsibilities = function () {
    $scope.$emit(checkOwnProfile(), UserManagementConstants.MANAGE_USERS_SCREENS.MARKETS_LEGS);
  };
  $scope.showWorkflowSettings = function () {
    $scope.$emit(checkOwnProfile(), UserManagementConstants.MANAGE_USERS_SCREENS.WORKFLOW_SETTINGS);
  };
  $scope.showDateTimeSettings = function () {
    $scope.$emit(checkOwnProfile(), UserManagementConstants.MANAGE_USERS_SCREENS.DATE_TIME_NUMBER_PREFS);
  };
  $scope.isPricing = function () {
    return FeatureToggleService.isEnabled('DYNAMIC_AVAILABILITY');
  };
  function checkOwnProfile() {
    if ($scope.isOwnProfile) {
      //inside user-profile-panel, handle appropriately
      return 'user-profile:change-screen';
    }

    //this assumes we are in the user-management workflow
    return 'user-management-manage-users:change-screen';
  }
};
UserProfileController.$inject = ['$scope', 'UserManagementConstants', 'FeatureToggleService'];
module.exports = UserProfileController;